import axios from 'axios';
import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import siteObjectToQuery from '../../utils/siteObjectToQuery';
import filterObjectToQuery from '../../utils/filterObjectToQuery';
import moment from 'moment';
import { i18n } from '../../translate/i18n';

const { CancelToken } = axios;

let fetchCalendars_cancel;
let fetchCalendarsExport_cancel;

export const fetchCalendarsSuccess = (calendarEvents, after, before) => ({
    type: actionTypes.FETCH_CALENDARS_SUCCESS,
    calendarEvents,
    after,
    before,
  });

export const requestCalendarsFail = error => ({
    type: actionTypes.REQUEST_CALENDARS_FAIL,
    error,
  });

export const requestCalendarsStart = () => ({
    type: actionTypes.REQUEST_CALENDARS_START,
  });

export const modalCalendarsOpen = ({ modalType, date, stage, title }) => ({
    type: actionTypes.MODAL_CALENDARS_OPEN,
    modalType,
    date,
    stage,
    title,
  });

export const modalCalendarsClose = () => ({
    type: actionTypes.MODAL_CALENDARS_CLOSE,
  });

export const setCalendarsDate = date => ({
    type: actionTypes.SET_CALENDARS_DATE,
    date,
  });

export const clearCalendarsState = () => ({
    type: actionTypes.CLEAR_CALENDARS_STATE,
  });

// filter
export const filterCalendarServiceTypes = (serviceTypes) => {
  return {
    type: actionTypes.FILTER_CALENDAR_SERVICE_TYPES,
    serviceTypes,
  };
};

export const filterCalendarServiceTypesRemove = (serviceType) => {
  return {
    type: actionTypes.FILTER_CALENDAR_SERVICE_TYPES_REMOVE,
    serviceType,
  };
};

export const filterCalendarFrequencies = (frequencies) => {
  return {
    type: actionTypes.FILTER_CALENDAR_FREQUENCIES,
    frequencies,
  };
};

export const filterCalendarFrequenciesRemove = (frequency) => {
  return {
    type: actionTypes.FILTER_CALENDAR_FREQUENCIES_REMOVE,
    frequency,
  };
};

export const filterCalendarStatus = status => ({
  type: actionTypes.FILTER_CALENDAR_STATUS,
  status,
});

export const filterCalendarStatusRemove = status  => ({
  type: actionTypes.FILTER_CALENDAR_STATUS_REMOVE,
  status,
});

export const filterCalendarStatusMaintenances = status => ({
  type: actionTypes.FILTER_CALENDAR_STATUS_MAINTENANCES,
  status,
});

export const filterCalendarStatusMaintenancesRemove = status  => ({
  type: actionTypes.FILTER_CALENDAR_STATUS_MAINTENANCES_REMOVE,
  status,
});

export const filterCalendarUsers = users => ({
    type: actionTypes.FILTER_CALENDAR_USERS,
    users,
});

export const filterCalendarUsersRemove = user => ({
    type: actionTypes.FILTER_CALENDAR_USERS_REMOVE,
    user,
});

export const filterCalendarUsersMaintenances = users => ({
  type: actionTypes.FILTER_CALENDAR_USERS_MAINTENANCES,
  users,
});

export const filterCalendarUsersMaintenancesRemove = user => ({
  type: actionTypes.FILTER_CALENDAR_USERS_MAINTENANCES_REMOVE,
  user,
});

export const filterCalendarEquipmentModels = equipmentModels => ({
    type: actionTypes.FILTER_CALENDAR_MODELS,
    equipmentModels,
});

export const filterCalendarEquipmentModelsRemove = equipmentModel => ({
    type: actionTypes.FILTER_CALENDAR_MODELS_REMOVE,
    equipmentModel,
});

export const filterCalendarEquipmentGroups = equipmentGroups => ({
    type: actionTypes.FILTER_CALENDAR_GROUPS,
    equipmentGroups,
});

export const filterCalendarEquipmentGroupsRemove = equipmentGroup => ({
    type: actionTypes.FILTER_CALENDAR_GROUPS_REMOVE,
    equipmentGroup,
});

export const filterCalendarPlaces = places => ({
    type: actionTypes.FILTER_CALENDAR_PLACES,
    places,
});

export const filterCalendarPlacesRemove = place => ({
    type: actionTypes.FILTER_CALENDAR_PLACES_REMOVE,
    place,
});

export const filterCalendarModules = modules => ({
  type: actionTypes.FILTER_CALENDAR_MODULES,
  modules  
});

export const filterCalendarModulesRemove = module => ({
    type: actionTypes.FILTER_CALENDAR_MODULES_REMOVE,
    module,
});

export const filterCalendarAreas = areas => ({
  type: actionTypes.FILTER_CALENDAR_AREAS,
  areas,
});

export const filterCalendarAreasRemove = area => ({
    type: actionTypes.FILTER_CALENDAR_AREAS_REMOVE,
    area,
});

export const filterCalendarCompanies = companies => ({
  type: actionTypes.FILTER_CALENDAR_COMPANIES,
  companies,
});

export const filterCalendarCompaniesRemove = company => ({
  type: actionTypes.FILTER_CALENDAR_COMPANIES_REMOVE,
  company,
});

export const filterCalendarClear = () => ({
    type: actionTypes.FILTER_CALENDAR_CLEAR,
});

export const fetchCalendars = (after, before, sites, filteredUsers, filteredUsersMaintenances, filteredEquipmentModels, filteredEquipmentGroups, filteredModules, filteredAreas, filteredCompanies, filteredPlaces, filteredServiceTypes = [], filteredFrequencies = [], filteredStatus, filteredStatusMaintenances) => {
  fetchCalendars_cancel && fetchCalendars_cancel();
  const afterISO = moment(after).toISOString()
  const beforeISO = moment(before).toISOString()

  return dispatch => new Promise((resolve, reject) => {
      dispatch(requestCalendarsStart());
      let queryParams = `?after=${afterISO}&before=${beforeISO}`;
      queryParams += `&${sites && sites.length > 0 ? `sites=${siteObjectToQuery(sites)}` : ''}`;
      queryParams += `${filteredUsers && filteredUsers.length > 0 ? `&users=${filterObjectToQuery(filteredUsers)}` : ''}`;
      queryParams += `${filteredUsersMaintenances && filteredUsersMaintenances.length > 0 ? `&usersMaintenances=${filterObjectToQuery(filteredUsersMaintenances)}` : ''}`;
      queryParams += `${filteredEquipmentModels && filteredEquipmentModels.length > 0 ? `&equipmentModel=${filterObjectToQuery(filteredEquipmentModels)}` : ''}`;
      queryParams += `${filteredEquipmentGroups && filteredEquipmentGroups.length > 0 ? `&equipmentGroup=${filterObjectToQuery(filteredEquipmentGroups)}` : ''}`;
      queryParams += `${filteredServiceTypes && filteredServiceTypes.length > 0 ? '&serviceType=' + filterObjectToQuery(filteredServiceTypes) : ''}`
      queryParams += `${filteredFrequencies && filteredFrequencies.length > 0 ? '&frequencies=' + filterObjectToQuery(filteredFrequencies) : ''}`
      queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? `&places=${filterObjectToQuery(filteredPlaces)}` : ''}`;
      queryParams += `${filteredModules && filteredModules.length > 0 ? `&modules=${filteredModules.join(',')}`:''}`;
      queryParams += `${filteredAreas && filteredAreas.length > 0 ? `&areas=${filterObjectToQuery(filteredAreas)}` : ''}`;
      queryParams += `${filteredCompanies && filteredCompanies.length > 0 ? `&companies=${filterObjectToQuery(filteredCompanies)}` : ''}`;
      queryParams += `${filteredStatus && filteredStatus.length > 0 ? `&status=${filterObjectToQuery(filteredStatus)}` : ''}`;
      queryParams += `${filteredStatusMaintenances && filteredStatusMaintenances.length > 0 ? `&statusMaintenances=${filterObjectToQuery(filteredStatusMaintenances)}` : ''}`;
   
      API.get(`/calendars/web${queryParams}`, {
        cancelToken: new CancelToken(((c) => {
          fetchCalendars_cancel = c;
        })),
      })
        .then((res) => {
          dispatch(fetchCalendarsSuccess(res.data, after, before));
          resolve('success');
        })
        .catch((err) => {
          dispatch(requestCalendarsFail(err));
        });
  });
};

const fetchCompletedActionsByDayStart = (isNew) => ({
  type: actionTypes.CALENDAR_FETCH_COMPLETED_ACTIONS_BYDAY_START,
  isNew,
})

const fetchCompletedActionsByDaySuccess = (payload) => ({
  type: actionTypes.CALENDAR_FETCH_COMPLETED_ACTIONS_BYDAY_SUCCESS,
  payload,
})

const fetchMoreCompletedActionsByDaySuccess = (payload) => ({
  type: actionTypes.CALENDAR_FETCH_MORE_COMPLETED_ACTIONS_BYDAY_SUCCESS,
  payload,
})

const fetchCompletedActionsByDayFail = () => ({
  type: actionTypes.CALENDAR_FETCH_COMPLETED_ACTIONS_BYDAY_FAIL,
})

export const fetchCompletedActionsByDay = (page, limit, date, sites, filteredUsers, filteredUsersMaintenances, filteredEquipmentModels, filteredEquipmentGroups, filteredModules, filteredAreas, filteredCompanies, filteredPlaces, filteredServiceTypes = [], filteredFrequencies = [], filteredStatus, filteredStatusMaintenances, isNew) => {
  fetchCalendars_cancel && fetchCalendars_cancel();
  const afterISO = moment(date).startOf('day').toISOString()
  const beforeISO = moment(date).endOf('day').toISOString()

  return dispatch => new Promise((resolve, reject) => {
      dispatch(fetchCompletedActionsByDayStart(isNew));
      let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&after=${afterISO}&before=${beforeISO}`;
      queryParams += `&${sites && sites.length > 0 ? `sites=${siteObjectToQuery(sites)}` : ''}`;
      queryParams += `${filteredUsers && filteredUsers.length > 0 ? `&users=${filterObjectToQuery(filteredUsers)}` : ''}`;
      queryParams += `${filteredUsersMaintenances && filteredUsersMaintenances.length > 0 ? `&usersMaintenances=${filterObjectToQuery(filteredUsersMaintenances)}` : ''}`;
      queryParams += `${filteredEquipmentModels && filteredEquipmentModels.length > 0 ? `&equipmentModel=${filterObjectToQuery(filteredEquipmentModels)}` : ''}`;
      queryParams += `${filteredEquipmentGroups && filteredEquipmentGroups.length > 0 ? `&equipmentGroup=${filterObjectToQuery(filteredEquipmentGroups)}` : ''}`;
      queryParams += `${filteredServiceTypes && filteredServiceTypes.length > 0 ? '&serviceType=' + filterObjectToQuery(filteredServiceTypes) : ''}`
      queryParams += `${filteredFrequencies && filteredFrequencies.length > 0 ? '&frequencies=' + filterObjectToQuery(filteredFrequencies) : ''}`
      queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? `&places=${filterObjectToQuery(filteredPlaces)}` : ''}`;
      queryParams += `${filteredModules && filteredModules.length > 0 ? `&modules=${filteredModules.join(',')}`:''}`;
      queryParams += `${filteredAreas && filteredAreas.length > 0 ? `&areas=${filterObjectToQuery(filteredAreas)}` : ''}`;
      queryParams += `${filteredCompanies && filteredCompanies.length > 0 ? `&companies=${filterObjectToQuery(filteredCompanies)}` : ''}`;
      queryParams += `${filteredStatus && filteredStatus.length > 0 ? `&status=${filterObjectToQuery(filteredStatus)}` : ''}`;
      queryParams += `${filteredStatusMaintenances && filteredStatusMaintenances.length > 0 ? `&statusMaintenances=${filterObjectToQuery(filteredStatusMaintenances)}` : ''}`;
   
      API.get(`/calendars/web/completedActionsByDay${queryParams}`, {
        cancelToken: new CancelToken(((c) => {
          fetchCalendars_cancel = c;
        })),
      })
        .then((res) => {
          if (isNew) dispatch(fetchCompletedActionsByDaySuccess(res.data));
          else dispatch(fetchMoreCompletedActionsByDaySuccess(res.data));
          resolve('success');
        })
        .catch((err) => {
          dispatch(fetchCompletedActionsByDayFail(err));
        });
  });
};

const fetchInProgressActionsByDayStart = (isNew) => ({
  type: actionTypes.CALENDAR_FETCH_INPROGRESS_ACTIONS_BYDAY_START,
  isNew,
})

const fetchInProgressActionsByDaySuccess = (payload) => ({
  type: actionTypes.CALENDAR_FETCH_INPROGRESS_ACTIONS_BYDAY_SUCCESS,
  payload,
})

const fetchMoreInProgressActionsByDaySuccess = (payload) => ({
  type: actionTypes.CALENDAR_FETCH_MORE_INPROGRESS_ACTIONS_BYDAY_SUCCESS,
  payload,
})

const fetchInProgressActionsByDayFail = () => ({
  type: actionTypes.CALENDAR_FETCH_INPROGRESS_ACTIONS_BYDAY_FAIL,
})

export const fetchInProgressActionsByDay = (page, limit, date, sites, filteredUsers, filteredUsersMaintenances, filteredEquipmentModels, filteredEquipmentGroups, filteredModules, filteredAreas, filteredCompanies, filteredPlaces, filteredServiceTypes = [], filteredFrequencies = [], filteredStatus, filteredStatusMaintenances, isNew) => {
  fetchCalendars_cancel && fetchCalendars_cancel();
  const afterISO = moment(date).startOf('day').toISOString()
  const beforeISO = moment(date).endOf('day').toISOString()

  return dispatch => new Promise((resolve, reject) => {
      dispatch(fetchInProgressActionsByDayStart(isNew));
      let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&after=${afterISO}&before=${beforeISO}`;
      queryParams += `&${sites && sites.length > 0 ? `sites=${siteObjectToQuery(sites)}` : ''}`;
      queryParams += `${filteredUsers && filteredUsers.length > 0 ? `&users=${filterObjectToQuery(filteredUsers)}` : ''}`;
      queryParams += `${filteredUsersMaintenances && filteredUsersMaintenances.length > 0 ? `&usersMaintenances=${filterObjectToQuery(filteredUsersMaintenances)}` : ''}`;
      queryParams += `${filteredEquipmentModels && filteredEquipmentModels.length > 0 ? `&equipmentModel=${filterObjectToQuery(filteredEquipmentModels)}` : ''}`;
      queryParams += `${filteredEquipmentGroups && filteredEquipmentGroups.length > 0 ? `&equipmentGroup=${filterObjectToQuery(filteredEquipmentGroups)}` : ''}`;
      queryParams += `${filteredServiceTypes && filteredServiceTypes.length > 0 ? '&serviceType=' + filterObjectToQuery(filteredServiceTypes) : ''}`
      queryParams += `${filteredFrequencies && filteredFrequencies.length > 0 ? '&frequencies=' + filterObjectToQuery(filteredFrequencies) : ''}`
      queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? `&places=${filterObjectToQuery(filteredPlaces)}` : ''}`;
      queryParams += `${filteredModules && filteredModules.length > 0 ? `&modules=${filteredModules.join(',')}`:''}`;
      queryParams += `${filteredAreas && filteredAreas.length > 0 ? `&areas=${filterObjectToQuery(filteredAreas)}` : ''}`;
      queryParams += `${filteredCompanies && filteredCompanies.length > 0 ? `&companies=${filterObjectToQuery(filteredCompanies)}` : ''}`;
      queryParams += `${filteredStatus && filteredStatus.length > 0 ? `&status=${filterObjectToQuery(filteredStatus)}` : ''}`;
      queryParams += `${filteredStatusMaintenances && filteredStatusMaintenances.length > 0 ? `&statusMaintenances=${filterObjectToQuery(filteredStatusMaintenances)}` : ''}`;
   
      API.get(`/calendars/web/inProgressActionsByDay${queryParams}`, {
        cancelToken: new CancelToken(((c) => {
          fetchCalendars_cancel = c;
        })),
      })
        .then((res) => {
          if (isNew) dispatch(fetchInProgressActionsByDaySuccess(res.data));
          else dispatch(fetchMoreInProgressActionsByDaySuccess(res.data));
          resolve('success');
        })
        .catch((err) => {
          dispatch(fetchInProgressActionsByDayFail(err));
        });
  });
};

const fetchCompletedServicesByDayStart = (isNew) => ({
  type: actionTypes.CALENDAR_FETCH_COMPLETED_SERVICES_BYDAY_START,
  isNew,
})

const fetchCompletedServicesByDaySuccess = (payload) => ({
  type: actionTypes.CALENDAR_FETCH_COMPLETED_SERVICES_BYDAY_SUCCESS,
  payload,
})

const fetchMoreCompletedServicesByDaySuccess = (payload) => ({
  type: actionTypes.CALENDAR_FETCH_MORE_COMPLETED_SERVICES_BYDAY_SUCCESS,
  payload,
})

const fetchCompletedServicesByDayFail = () => ({
  type: actionTypes.CALENDAR_FETCH_COMPLETED_SERVICES_BYDAY_FAIL,
})

export const fetchCompletedServicesByDay = (page, limit, date, sites, filteredUsers, filteredUsersMaintenances, filteredEquipmentModels, filteredEquipmentGroups, filteredModules, filteredAreas, filteredCompanies, filteredPlaces, filteredServiceTypes = [], filteredFrequencies = [], filteredStatus, filteredStatusMaintenances, isNew) => {
  fetchCalendars_cancel && fetchCalendars_cancel();
  const afterISO = moment(date).startOf('day').toISOString()
  const beforeISO = moment(date).endOf('day').toISOString()

  return dispatch => new Promise((resolve, reject) => {
      dispatch(fetchCompletedServicesByDayStart(isNew));
      let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&after=${afterISO}&before=${beforeISO}`;
      queryParams += `&${sites && sites.length > 0 ? `sites=${siteObjectToQuery(sites)}` : ''}`;
      queryParams += `${filteredUsers && filteredUsers.length > 0 ? `&users=${filterObjectToQuery(filteredUsers)}` : ''}`;
      queryParams += `${filteredUsersMaintenances && filteredUsersMaintenances.length > 0 ? `&usersMaintenances=${filterObjectToQuery(filteredUsersMaintenances)}` : ''}`;
      queryParams += `${filteredEquipmentModels && filteredEquipmentModels.length > 0 ? `&equipmentModel=${filterObjectToQuery(filteredEquipmentModels)}` : ''}`;
      queryParams += `${filteredEquipmentGroups && filteredEquipmentGroups.length > 0 ? `&equipmentGroup=${filterObjectToQuery(filteredEquipmentGroups)}` : ''}`;
      queryParams += `${filteredServiceTypes && filteredServiceTypes.length > 0 ? '&serviceType=' + filterObjectToQuery(filteredServiceTypes) : ''}`
      queryParams += `${filteredFrequencies && filteredFrequencies.length > 0 ? '&frequencies=' + filterObjectToQuery(filteredFrequencies) : ''}`
      queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? `&places=${filterObjectToQuery(filteredPlaces)}` : ''}`;
      queryParams += `${filteredModules && filteredModules.length > 0 ? `&modules=${filteredModules.join(',')}`:''}`;
      queryParams += `${filteredAreas && filteredAreas.length > 0 ? `&areas=${filterObjectToQuery(filteredAreas)}` : ''}`;
      queryParams += `${filteredCompanies && filteredCompanies.length > 0 ? `&companies=${filterObjectToQuery(filteredCompanies)}` : ''}`;
      queryParams += `${filteredStatus && filteredStatus.length > 0 ? `&status=${filterObjectToQuery(filteredStatus)}` : ''}`;
      queryParams += `${filteredStatusMaintenances && filteredStatusMaintenances.length > 0 ? `&statusMaintenances=${filterObjectToQuery(filteredStatusMaintenances)}` : ''}`;
   
      API.get(`/calendars/web/completedServicesByDay${queryParams}`, {
        cancelToken: new CancelToken(((c) => {
          fetchCalendars_cancel = c;
        })),
      })
        .then((res) => {
          if (isNew) dispatch(fetchCompletedServicesByDaySuccess(res.data));
          else dispatch(fetchMoreCompletedServicesByDaySuccess(res.data));
          resolve('success');
        })
        .catch((err) => {
          dispatch(fetchCompletedServicesByDayFail(err));
        });
  });
};

const fetchInProgressServicesByDayStart = (isNew) => ({
  type: actionTypes.CALENDAR_FETCH_INPROGRESS_SERVICES_BYDAY_START,
  isNew,
})

const fetchInProgressServicesByDaySuccess = (payload) => ({
  type: actionTypes.CALENDAR_FETCH_INPROGRESS_SERVICES_BYDAY_SUCCESS,
  payload,
})

const fetchMoreInProgressServicesByDaySuccess = (payload) => ({
  type: actionTypes.CALENDAR_FETCH_MORE_INPROGRESS_SERVICES_BYDAY_SUCCESS,
  payload,
})

const fetchInProgressServicesByDayFail = () => ({
  type: actionTypes.CALENDAR_FETCH_INPROGRESS_SERVICES_BYDAY_FAIL,
})

export const fetchInProgressServicesByDay = (page, limit, date, sites, filteredUsers, filteredUsersMaintenances, filteredEquipmentModels, filteredEquipmentGroups, filteredModules, filteredAreas, filteredCompanies, filteredPlaces, filteredServiceTypes = [], filteredFrequencies = [], filteredStatus, filteredStatusMaintenances, isNew) => {
  fetchCalendars_cancel && fetchCalendars_cancel();
  const afterISO = moment(date).startOf('day').toISOString()
  const beforeISO = moment(date).endOf('day').toISOString()

  return dispatch => new Promise((resolve, reject) => {
      dispatch(fetchInProgressServicesByDayStart(isNew));
      let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&after=${afterISO}&before=${beforeISO}`;
      queryParams += `&${sites && sites.length > 0 ? `sites=${siteObjectToQuery(sites)}` : ''}`;
      queryParams += `${filteredUsers && filteredUsers.length > 0 ? `&users=${filterObjectToQuery(filteredUsers)}` : ''}`;
      queryParams += `${filteredUsersMaintenances && filteredUsersMaintenances.length > 0 ? `&usersMaintenances=${filterObjectToQuery(filteredUsersMaintenances)}` : ''}`;
      queryParams += `${filteredEquipmentModels && filteredEquipmentModels.length > 0 ? `&equipmentModel=${filterObjectToQuery(filteredEquipmentModels)}` : ''}`;
      queryParams += `${filteredEquipmentGroups && filteredEquipmentGroups.length > 0 ? `&equipmentGroup=${filterObjectToQuery(filteredEquipmentGroups)}` : ''}`;
      queryParams += `${filteredServiceTypes && filteredServiceTypes.length > 0 ? '&serviceType=' + filterObjectToQuery(filteredServiceTypes) : ''}`
      queryParams += `${filteredFrequencies && filteredFrequencies.length > 0 ? '&frequencies=' + filterObjectToQuery(filteredFrequencies) : ''}`
      queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? `&places=${filterObjectToQuery(filteredPlaces)}` : ''}`;
      queryParams += `${filteredModules && filteredModules.length > 0 ? `&modules=${filteredModules.join(',')}`:''}`;
      queryParams += `${filteredAreas && filteredAreas.length > 0 ? `&areas=${filterObjectToQuery(filteredAreas)}` : ''}`;
      queryParams += `${filteredCompanies && filteredCompanies.length > 0 ? `&companies=${filterObjectToQuery(filteredCompanies)}` : ''}`;
      queryParams += `${filteredStatus && filteredStatus.length > 0 ? `&status=${filterObjectToQuery(filteredStatus)}` : ''}`;
      queryParams += `${filteredStatusMaintenances && filteredStatusMaintenances.length > 0 ? `&statusMaintenances=${filterObjectToQuery(filteredStatusMaintenances)}` : ''}`;
   
      API.get(`/calendars/web/inProgressServicesByDay${queryParams}`, {
        cancelToken: new CancelToken(((c) => {
          fetchCalendars_cancel = c;
        })),
      })
        .then((res) => {
          if (isNew) dispatch(fetchInProgressServicesByDaySuccess(res.data));
          else dispatch(fetchMoreInProgressServicesByDaySuccess(res.data));
          resolve('success');
        })
        .catch((err) => {
          dispatch(fetchInProgressServicesByDayFail(err));
        });
  });
};

const fetchMaintenancesByDayStart = (isNew) => ({
  type: actionTypes.CALENDAR_FETCH_MAINTENANCES_BYDAY_START,
  isNew,
})

const fetchMaintenancesByDaySuccess = (payload) => ({
  type: actionTypes.CALENDAR_FETCH_MAINTENANCES_BYDAY_SUCCESS,
  payload,
})

const fetchMoreMaintenancesByDaySuccess = (payload) => ({
  type: actionTypes.CALENDAR_FETCH_MAINTENANCES_BYDAY_SUCCESS,
  payload,
})

const fetchMaintenancesByDayFail = () => ({
  type: actionTypes.CALENDAR_FETCH_MAINTENANCES_BYDAY_FAIL,
})

export const fetchMaintenancesByDay = (page, limit, date, sites, filteredUsers, filteredUsersMaintenances, filteredEquipmentModels, filteredEquipmentGroups, filteredModules, filteredAreas, filteredCompanies, filteredPlaces, filteredServiceTypes = [], filteredFrequencies = [], filteredStatus, filteredStatusMaintenances, isNew) => {
  fetchCalendars_cancel && fetchCalendars_cancel();
  const afterISO = moment(date).startOf('day').toISOString()
  const beforeISO = moment(date).endOf('day').toISOString()

  return dispatch => new Promise((resolve, reject) => {
      dispatch(fetchMaintenancesByDayStart(isNew));
      let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&after=${afterISO}&before=${beforeISO}`;
      queryParams += `&${sites && sites.length > 0 ? `sites=${siteObjectToQuery(sites)}` : ''}`;
      queryParams += `${filteredUsers && filteredUsers.length > 0 ? `&users=${filterObjectToQuery(filteredUsers)}` : ''}`;
      queryParams += `${filteredUsersMaintenances && filteredUsersMaintenances.length > 0 ? `&usersMaintenances=${filterObjectToQuery(filteredUsersMaintenances)}` : ''}`;
      queryParams += `${filteredEquipmentModels && filteredEquipmentModels.length > 0 ? `&equipmentModel=${filterObjectToQuery(filteredEquipmentModels)}` : ''}`;
      queryParams += `${filteredEquipmentGroups && filteredEquipmentGroups.length > 0 ? `&equipmentGroup=${filterObjectToQuery(filteredEquipmentGroups)}` : ''}`;
      queryParams += `${filteredServiceTypes && filteredServiceTypes.length > 0 ? '&serviceType=' + filterObjectToQuery(filteredServiceTypes) : ''}`
      queryParams += `${filteredFrequencies && filteredFrequencies.length > 0 ? '&frequencies=' + filterObjectToQuery(filteredFrequencies) : ''}`
      queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? `&places=${filterObjectToQuery(filteredPlaces)}` : ''}`;
      queryParams += `${filteredModules && filteredModules.length > 0 ? `&modules=${filteredModules.join(',')}`:''}`;
      queryParams += `${filteredAreas && filteredAreas.length > 0 ? `&areas=${filterObjectToQuery(filteredAreas)}` : ''}`;
      queryParams += `${filteredCompanies && filteredCompanies.length > 0 ? `&companies=${filterObjectToQuery(filteredCompanies)}` : ''}`;
      queryParams += `${filteredStatus && filteredStatus.length > 0 ? `&status=${filterObjectToQuery(filteredStatus)}` : ''}`;
      queryParams += `${filteredStatusMaintenances && filteredStatusMaintenances.length > 0 ? `&statusMaintenances=${filterObjectToQuery(filteredStatusMaintenances)}` : ''}`;
   
      API.get(`/calendars/web/maintenancesByDay${queryParams}`, {
        cancelToken: new CancelToken(((c) => {
          fetchCalendars_cancel = c;
        })),
      })
        .then((res) => {
          if (isNew) dispatch(fetchMaintenancesByDaySuccess(res.data));
          else dispatch(fetchMoreMaintenancesByDaySuccess(res.data));
          resolve('success');
        })
        .catch((err) => {
          dispatch(fetchMaintenancesByDayFail(err));
        });
  });
};

export const fetchCalendarPdfExportStart = () => ({
  type: actionTypes.CALENDAR_FETCH_PDF_REPORT_START,
});

export const fetchCalendarPdfExportSuccess = () => ({
  type: actionTypes.CALENDAR_FETCH_PDF_REPORT_SUCCESS,
});

export const fetchCalendarPdfExportFail = () => ({
  type: actionTypes.CALENDAR_FETCH_PDF_REPORT_FAIL,
});

export const fetchCalendarsPdfExport = (after, before, sites, filteredUsers, filteredUsersMaintenances, filteredEquipmentModels, filteredEquipmentGroups, filteredModules, filteredAreas, filteredCompanies, filteredPlaces, filteredServiceTypes = [], filteredFrequencies = [], filteredStatus, filteredStatusMaintenances, emailLanguage) => {
  fetchCalendars_cancel && fetchCalendars_cancel();
  const afterISO = moment(after).toISOString()
  const beforeISO = moment(before).toISOString()

  return dispatch => new Promise((resolve, reject) => {
      toastr.info(i18n.t('toastrFileDownBtn.info1'), i18n.t('toastrFileDownBtn.info2'));
      dispatch(fetchCalendarPdfExportStart());

      let queryParams = `?after=${afterISO}&before=${beforeISO}`;
      queryParams += `&${sites && sites.length > 0 ? `sites=${siteObjectToQuery(sites)}` : ''}`;
      queryParams += `${filteredUsers && filteredUsers.length > 0 ? `&users=${filterObjectToQuery(filteredUsers)}` : ''}`;
      queryParams += `${filteredUsersMaintenances && filteredUsersMaintenances.length > 0 ? `&usersMaintenances=${filterObjectToQuery(filteredUsersMaintenances)}` : ''}`;
      queryParams += `${filteredEquipmentModels && filteredEquipmentModels.length > 0 ? `&equipmentModel=${filterObjectToQuery(filteredEquipmentModels)}` : ''}`;
      queryParams += `${filteredEquipmentGroups && filteredEquipmentGroups.length > 0 ? `&equipmentGroup=${filterObjectToQuery(filteredEquipmentGroups)}` : ''}`;
      queryParams += `${filteredServiceTypes && filteredServiceTypes.length > 0 ? '&serviceType=' + filterObjectToQuery(filteredServiceTypes) : ''}`
      queryParams += `${filteredFrequencies && filteredFrequencies.length > 0 ? '&frequencies=' + filterObjectToQuery(filteredFrequencies) : ''}`
      queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? `&places=${filterObjectToQuery(filteredPlaces)}` : ''}`;
      queryParams += `${filteredModules && filteredModules.length > 0 ? `&modules=${filteredModules.join(',')}`:''}`;
      queryParams += `${filteredAreas && filteredAreas.length > 0 ? `&areas=${filterObjectToQuery(filteredAreas)}` : ''}`;
      queryParams += `${filteredCompanies && filteredCompanies.length > 0 ? `&companies=${filterObjectToQuery(filteredCompanies)}` : ''}`;
      queryParams += `${filteredStatus && filteredStatus.length > 0 ? `&status=${filterObjectToQuery(filteredStatus)}` : ''}`;
      queryParams += `${filteredStatusMaintenances && filteredStatusMaintenances.length > 0 ? `&statusMaintenances=${filterObjectToQuery(filteredStatusMaintenances)}` : ''}`;
      queryParams += `${emailLanguage && emailLanguage.length > 0 ? `&emailLanguage=${emailLanguage}` : 'pt'}`;
   
      API.get(`/calendars/equipment_report${queryParams}`, {
        cancelToken: new CancelToken(((c) => {
          fetchCalendars_cancel = c;
        })),
      })
        .then((res) => {
          dispatch(fetchCalendarPdfExportSuccess());
          window.open(res.data.url);
          resolve('success');
        })
        .catch((err) => {
          dispatch(fetchCalendarPdfExportFail());
          console.log(err);
          toastr.error(i18n.t('toastrFileDownBtn.error1'), i18n.t('toastrFileDownBtn.error2'));
        });
  });
};

export const fetchCalendarsExport = (after, before, sites, filteredUsers, filteredUsersMaintenances, filteredEquipmentModels, filteredEquipmentGroups, filteredServiceTypes, filteredFrequencies, filteredPlaces, filteredModules, filteredStatus, filteredStatusMaintenances, filteredAreas, filteredCompanies, emailLanguage) => {
  fetchCalendarsExport_cancel && fetchCalendarsExport_cancel();

  const afterISO = moment(after).toISOString()
  const beforeISO = moment(before).toISOString()

  
  return dispatch => new Promise((resolve, reject) => {
    dispatch(fetchCalendarPdfExportStart());
    let queryParams = `?after=${afterISO}&before=${beforeISO}`;
    queryParams += `&${sites && sites.length > 0 ? `sites=${siteObjectToQuery(sites)}` : ''}`;
    queryParams += `${filteredUsers && filteredUsers.length > 0 ? `&users=${filterObjectToQuery(filteredUsers)}` : ''}`;
    queryParams += `${filteredUsersMaintenances && filteredUsersMaintenances.length > 0 ? `&usersMaintenances=${filterObjectToQuery(filteredUsersMaintenances)}` : ''}`;
    queryParams += `${filteredEquipmentModels && filteredEquipmentModels.length > 0 ? `&equipmentModel=${filterObjectToQuery(filteredEquipmentModels)}` : ''}`;
    queryParams += `${filteredEquipmentGroups && filteredEquipmentGroups.length > 0 ? `&equipmentGroup=${filterObjectToQuery(filteredEquipmentGroups)}` : ''}`;
    queryParams += `${filteredServiceTypes && filteredServiceTypes.length > 0 ? '&serviceType=' + filterObjectToQuery(filteredServiceTypes) : ''}`
    queryParams += `${filteredFrequencies && filteredFrequencies.length > 0 ? '&frequencies=' + filterObjectToQuery(filteredFrequencies) : ''}`
    queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? `&places=${filterObjectToQuery(filteredPlaces)}` : ''}`;
    queryParams += `${filteredModules && filteredModules.length > 0 ? `&modules=${filteredModules.join(',')}`:''}`;
    queryParams += `${filteredStatus && filteredStatus.length > 0 ? `&status=${filterObjectToQuery(filteredStatus)}` : ''}`;
    queryParams += `${filteredStatusMaintenances && filteredStatusMaintenances.length > 0 ? `&statusMaintenances=${filterObjectToQuery(filteredStatusMaintenances)}` : ''}`;
    queryParams += `${filteredAreas && filteredAreas.length > 0 ? `&areas=${filterObjectToQuery(filteredAreas)}` : ''}`;
    queryParams += `${filteredCompanies && filteredCompanies.length > 0 ? `&companies=${filterObjectToQuery(filteredCompanies)}` : ''}`;
    queryParams += `${emailLanguage && emailLanguage.length > 0 ? `&emailLanguage=${emailLanguage}` : 'pt'}`;
 
    API.get(`/calendars/export${queryParams}`, {
      cancelToken: new CancelToken(((c) => {
        fetchCalendarsExport_cancel = c;
      })),
    })
      .then((res) => {;
        dispatch(fetchCalendarPdfExportSuccess());
        window.open(res.data.url);
        resolve('success');
      })
      .catch((err) => {
        dispatch(fetchCalendarPdfExportFail());
        console.log(err);
        toastr.error(i18n.t('toastrFileDownBtn.error1'), i18n.t('toastrFileDownBtn.error2'));
      });
  });
}


